import { render, staticRenderFns } from "./LogAndNotice.vue?vue&type=template&id=4937298d"
import script from "./LogAndNotice.vue?vue&type=script&lang=js"
export * from "./LogAndNotice.vue?vue&type=script&lang=js"
import style0 from "./LogAndNotice.vue?vue&type=style&index=0&id=4937298d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports